import { createServerFn } from "@tanstack/react-start";
import { queryOptions } from "@tanstack/react-query";
import { supabaseUserMiddleware } from "@/middleware/supabase-user-middleware";
import { createClient } from "@/lib/supabase/admin";
import { SalesChannels } from "./channel";

export interface StorefrontTag {
  id: string;
  name: string;
  color: string | null;
  position: number;
}

export const storefrontTagsQueryOptions = () =>
  queryOptions({
    queryKey: ["storefront", "tags"],
    queryFn: () => fetchStorefrontTags(),
  });

/**
 * The merchant's product tags, offered as catalogue filters. The catalogue
 * hides the ones no listed product carries.
 */
export const fetchStorefrontTags = createServerFn({ method: "GET" })
  .middleware([supabaseUserMiddleware])
  .handler(async ({ context: { userId, channel } }): Promise<StorefrontTag[]> => {
    if (channel !== SalesChannels.storefront) return [];

    const { data, error } = await createClient()
      .from("product_tag")
      .select("id, name, color, position")
      .eq("user_id", userId)
      .order("position", { ascending: true })
      .order("name", { ascending: true });

    if (error) {
      console.error("Could not get product tags", error);
      throw new Error("Could not get product tags.");
    }

    return data;
  });
